$(document).ready(function() {
	$(document).on('click', '.js-excursion-result-item', function() {
		$(this).remove();
	});
});



// WEBPACK FOOTER //
// ./src/js/pages/modal-excursion/excursion-result.js